import * as React from "react";
import Helper from "../../../../core/libraries/Helper";
import { DatePicker } from "@fluentui/react/lib/DatePicker";
import _ from "lodash";
import RbLabel, {
  LabelSize,
} from "../../../../bosch-react/components/label/RbLabel";
import RbButton, {
  ButtonType,
  ButtonSize,
} from "../../../../bosch-react/components/button/RbButton";
import { updateURLWithRefinements } from "../../thunks";

class Search_Refinement_ReportDate extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      MinDate: null,
      MaxDate: null,
    };
    this.setLimitation = this.setLimitation.bind(this);
    this.setDefaultValues = this.setDefaultValues.bind(this);

    this.handleSearch = this.handleSearch.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
  }

  setDefaultValues(value: any) {
    if (value !== "") {
      const fromTo = this.extractDatesFromFilterString(value);

      this.setState({
        MinDate: !!fromTo.fromDate ? new Date(fromTo.fromDate) : null,
        MaxDate: !!fromTo.toDate ? new Date(fromTo.toDate) : null,
      })
    }
  }

  render() {
    return (
      <div className="ms-Grid" style={{ marginBottom: "1.5rem" }}>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <RbLabel hasPadding={true}>Report Date</RbLabel>
          </div>
          <div className="ms-Grid-col ms-sm12">
            <RbLabel size={LabelSize.Small}>From</RbLabel>
          </div>
          <div className="ms-Grid-col ms-sm12">
            <DatePicker
              showGoToToday={false}
              placeholder="Select a date..."
              formatDate={(data) => Helper.getDateTimeFormatForUI(data)}
              onSelectDate={(data) => this.setLimitation("min", data)}
              maxDate={
                _.isNil(this.state.MaxDate) ? undefined : this.state.MaxDate
              }
              value={this.state.MinDate}
            />
          </div>
          <div className="ms-Grid-col ms-sm12">
            <RbLabel size={LabelSize.Small}>To</RbLabel>
          </div>
          <div className="ms-Grid-col ms-sm12">
            <DatePicker
              showGoToToday={false}
              placeholder="Select a date..."
              formatDate={(data) => Helper.getDateTimeFormatForUI(data)}
              onSelectDate={(data) => this.setLimitation("max", data)}
              minDate={
                _.isNil(this.state.MinDate) ? undefined : this.state.MinDate
              }
              value={this.state.MaxDate}
            />
          </div>
          <div className="ms-Grid-col ms-sm12" style={{ marginTop: "10px" }}>
            <RbButton
              type={ButtonType.Secondary}
              size={ButtonSize.Tiny}
              label="Refine"
              style={{ minWidth: "3rem" }}
              onClick={this.handleSearch}
            />
            <RbButton
              type={ButtonType.Secondary}
              size={ButtonSize.Tiny}
              label="Clear"
              style={{ minWidth: "3rem" }}
              onClick={this.clearSearch}
            />
          </div>
        </div>
      </div>
    );
  }

  extractDatesFromFilterString(dateString: string): { fromDate: string; toDate: string } {
    const gtRegex = /DocumentDate gt (\S+)/;
    const ltRegex = /DocumentDate lt (\S+)/;

    const fromDateMatch = dateString.match(gtRegex);
    const toDateMatch = dateString.match(ltRegex);

    return {
      fromDate: fromDateMatch ? fromDateMatch[1] : '', // If 'gt' match found, use it, else empty
      toDate: toDateMatch ? toDateMatch[1] : '', // If 'lt' match found, use it, else empty
    };
  }

  setLimitation(limitPoint: any, value: any) {
    if (!_.isNil(value)) {
      let property = limitPoint === "min" ? "MinDate" : "MaxDate";
      let updatedObj: any = {};
      updatedObj[property] = value;
      this.setState(updatedObj);
    }
  }

  handleSearch() {
    if (!_.isNil(this.state.MinDate) && !_.isNil(this.state.MaxDate)) {
      let queryText = "DocumentDate gt ";
      queryText += new Date(this.state.MinDate).toISOString();
      queryText += " and DocumentDate lt ";
      queryText += new Date(this.state.MaxDate).toISOString();
      this.props.handleSearch("reportdate", queryText);
    } else {
      if (!_.isNil(this.state.MinDate)) {
        let queryText = "DocumentDate gt ";
        queryText += new Date(this.state.MinDate).toISOString();
        this.props.handleSearch("reportdate", queryText);
      } else if (!_.isNil(this.state.MaxDate)) {
        let queryText = "DocumentDate lt "
        queryText += new Date(this.state.MaxDate).toISOString();
        this.props.handleSearch("reportdate", queryText);
      }
    }
  }

  clearSearch() {
    this.props.handleSearch("reportdate", "");
    this.setState({
      MinDate: null,
      MaxDate: null,
    });
  }
}

export default Search_Refinement_ReportDate;
